export enum LemonWebhookStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  UNHANDLED = 'UNHANDLED',
}
